import React from 'react'

class FileSelector extends React.Component {
    constructor(){
        super()
        this.handleChange = this.handleChange.bind(this)
        this.trigger = this.trigger.bind(this)
    }
    trigger(){
        this.refs.file_selector.click()
    }
    handleChange(e){
        const files = e.target.files
        const callback = this.props.handleChoose
        var ff = i => {
            if(i >= files.length) 
                return

            let blob = files[i]
            let a = new FileReader()
            a.onload = function (e2) {
                let dataUri = e2.target.result
                console.log(i, blob.name)
                callback(blob, dataUri)
                ff(i + 1)    
            }
            a.readAsDataURL(blob)
        }
        ff(0) 
    }
    render(){
        return <input type="file" ref="file_selector"  style={{ display: 'none' }}
            multiple={this.props.multiple}
            onChange={this.handleChange}
            accept={this.props.accept} />
    }
}

export default FileSelector



// WEBPACK FOOTER //
// ./src/components/FileSelector.js